export default __webpack_public_path__ + "static/media/protein.96d1ac49.png";